import { Controller } from "@hotwired/stimulus";

// The filter of the member list. The form targets the `people-list` Turbo
// Frame; changing any field submits it after a short pause (typing a search
// text submits once, not once per key).
export default class extends Controller {
  static values = { delay: { type: Number, default: 400 } };

  queue() {
    this.cancel();
    this.timer = setTimeout(() => this.element.requestSubmit(), this.delayValue);
  }

  cancel() {
    clearTimeout(this.timer);
  }

  disconnect() {
    this.cancel();
  }
}
